import { render } from "./CheckEntriesView.vue?vue&type=template&id=35139ff6"
import script from "./CheckEntriesView.vue?vue&type=script&lang=js"
export * from "./CheckEntriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__